import { useEffect } from "react";
import { Text } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { Loader } from "@mantine/core";

import { translateFedexDeliveryStatusCode } from "../../utils/shipping.utils";

import { CarrierType } from "../../types/enums";
import { displayDate } from "../../utils/date.utils";
import { useQuery } from "@apollo/client";
import { GetOrderDeliveryInfoDocument } from "../../gql/generated/graphql";

type CarrierDeliveryInfoProps = {
  orderId: string;
  deliveryCarrier: CarrierType;
};

const CarrierDeliveryInfo = ({
  orderId,
  deliveryCarrier,
}: CarrierDeliveryInfoProps) => {
  const { data, error, loading } = useQuery(GetOrderDeliveryInfoDocument, {
    fetchPolicy: "network-only",
    variables: { orderId },
  });

  useEffect(() => {
    if (error) {
      notifications.show({
        title:
          "Erreur survenue en essayant de charger les informations auprès du transporteur",
        color: "red",
        message: "",
      });
    }
  }, [error]);

  if (loading) {
    return (
      <div style={{ textAlign: "center" }}>
        <Loader color="blue" />
        <Text>Chargement des informations du transporteur...</Text>
      </div>
    );
  }

  if (data?.getOrderDeliveryInfo?.length === 0) {
    return <>Il n'y a aucun information pour le moment.</>;
  }

  return (
    <ul>
      {data.getOrderDeliveryInfo.map(info => {
        const translationStatus = translateFedexDeliveryStatusCode(
          info.eventType,
          deliveryCarrier
        );

        return translationStatus ? (
          <li key={`${info.date}-${info.eventType}`}>
            {displayDate(new Date(info.date))}: {translationStatus}
          </li>
        ) : null;
      })}
    </ul>
  );
};

export default CarrierDeliveryInfo;
